import type { MouseEvent as ReactMouseEvent } from "react";

import { compactIdDisplay } from "./CopyableId";

interface OpportunitySetLinkProps {
  setId: string;
  setName: string | null;
  href?: string;
  onOpen?: (event: ReactMouseEvent<HTMLAnchorElement>) => void;
}

/** Source-context control: the set name (or compact id) is the reveal link. */
export function OpportunitySetLink({
  setId,
  setName,
  href,
  onOpen,
}: OpportunitySetLinkProps) {
  const label = setName || compactIdDisplay(setId);
  const linkClass =
    "min-w-0 truncate font-medium text-primary hover:text-primary/80";

  if (!href) {
    return (
      <span title={setId} className="min-w-0 truncate">
        {label}
      </span>
    );
  }

  return (
    <a href={href} title={setId} className={linkClass} onClick={onOpen}>
      {label}
    </a>
  );
}
